import React from 'react'

import { withRouter } from 'react-router-dom'
import { AuthContext } from '../../main/ProvedorAutenticacao'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { Toast } from 'primereact/toast';

import NavBar from '../../componentes/Navbar'

import './central.css'

class CentralAtividades extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return(
      <>
        <NavBar />
        <Toast ref={(el) => this.toast = el} />
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={this.state.openSpinner}>
          <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
        </Backdrop>
      </>
    )
  }
}

CentralAtividades.contextType = AuthContext;
export default withRouter (CentralAtividades)